import { getStore } from 'core_main/store';
import { fetchCurrentTrackingToken } from 'core_main/api/tracking';
import { handleError } from 'globals/errors';
import { IsLoggedInParameters } from './types';

export const userIsLoggedIn = ({
  userIdentifier,
  externalId,
  email,
  verified,
}) => {
  return verified && [externalId, email].includes(userIdentifier);
};

export const isLoggedIn = (parameters: IsLoggedInParameters, cb) => {
  const userIdentifier = parameters?.email || parameters?.externalId;
  if (!userIdentifier) return Promise.resolve(cb(false));

  const store = getStore();
  const { externalId, email, verified } = store;
  if (verified !== undefined) {
    const loggedIn = userIsLoggedIn({
      userIdentifier,
      externalId,
      email,
      verified,
    });
    if (typeof cb === 'function') return Promise.resolve(cb(loggedIn));
    return loggedIn;
  }

  return fetchCurrentTrackingToken()
    .then((response) => {
      const { externalId, email, verified } = response.data.attributes;
      const loggedIn = userIsLoggedIn({
        userIdentifier,
        externalId,
        email,
        verified,
      });
      if (typeof cb === 'function') return cb(loggedIn);
      return loggedIn;
    })
    .catch((error) => {
      if (typeof cb === 'function') cb(null, error);
      handleError(error, { message: `Failed to check user is logged in:` });
    });
};
